
export interface TimeoutConfig {
    idleTimeoutMinutes: number;
    idleWarningMinutes: number;
    warnTimeout: boolean;
    allowExpiration: boolean;
}

export enum TokenValidationExceptionMessages {
    NonExistent = "Attempt to use non-existent token",
    InvalidIP = "Attempt to refresh token from different IP address",
    Expired = "Attempt to refresh an expired token",
    Revoked = "Attempt to use a revoked token"
}